import { render, staticRenderFns } from "./UploadLogo.vue?vue&type=template&id=74247c3c&scoped=true"
import script from "./UploadLogo.vue?vue&type=script&lang=js"
export * from "./UploadLogo.vue?vue&type=script&lang=js"
import style0 from "./UploadLogo.vue?vue&type=style&index=0&id=74247c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74247c3c",
  null
  
)

export default component.exports